// extracted by mini-css-extract-plugin
export default {"aboutcontent":"About_aboutcontent__Nm1nx","slideDown":"About_slideDown__TWAuM"};